import { render, staticRenderFns } from "./Manage_module.vue?vue&type=template&id=1289e18c&"
import script from "./Manage_module.vue?vue&type=script&lang=js&"
export * from "./Manage_module.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports